import React, { useState, useEffect } from "react";

const CONSENT_KEY = "cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      // Show banner after 1.5s to not distract on urgent visits
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
    if (consent === "accepted" && window.posthog) {
      window.posthog.opt_in_capturing();
    }
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
    if (window.posthog) window.posthog.opt_in_capturing();
  };

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 z-[9990]"
      data-testid="cookie-consent-banner"
      style={{ animation: "fadeInUp 0.4s ease" }}
    >
      <div
        className="max-w-[1140px] mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4 px-6 py-5"
        style={{
          backgroundColor: "#1a1a1a",
          border: "1px solid rgba(198,168,90,0.25)",
          borderRadius: "16px",
          boxShadow: "0 8px 40px rgba(0,0,0,0.5)",
        }}
      >
        <div className="flex-1">
          <p className="text-sm leading-relaxed" style={{ color: "rgba(255,255,255,0.75)" }}>
            Folosim cookie-uri analytics pentru a înțelege cum este utilizat site-ul și a-l îmbunătăți.
            Nu colectăm date personale identificabile.
          </p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={decline}
            data-testid="cookie-decline-btn"
            className="text-sm cursor-pointer bg-transparent border-none px-4 py-2 transition-colors"
            style={{ color: "rgba(255,255,255,0.40)" }}
            onMouseEnter={e => (e.target.style.color = "rgba(255,255,255,0.70)")}
            onMouseLeave={e => (e.target.style.color = "rgba(255,255,255,0.40)")}
          >
            Refuz
          </button>
          <button
            onClick={accept}
            data-testid="cookie-accept-btn"
            className="text-sm font-semibold px-5 py-2.5 cursor-pointer border-none transition-all hover:opacity-90"
            style={{ backgroundColor: "var(--gold)", color: "#0f0f0f", borderRadius: "8px" }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
